/**
 * Destinations plotted on the globe.
 *
 * `lat`/`lon` are the city we draw the arc into — a recognisable landing point
 * rather than a country centroid, which on a sphere reads as nowhere.
 * Order matters: this is also the reading order of the list beside the globe.
 */

export const ORIGIN = {
  id: "mumbai",
  label: "Mumbai",
  sub: "Andheri West",
  lat: 19.076,
  lon: 72.877,
};

export const DESTINATIONS = [
  {
    id: "canada",
    country: "Canada",
    city: "Toronto",
    lat: 43.65,
    lon: -79.38,
    code: "CA",
    route: "Express Entry · PNP · Study",
    headline: "Permanent residency with a route you can actually see",
    detail:
      "Express Entry, Provincial Nominee streams and 90+ DLI partner colleges — with CRS optimisation before you file, not after.",
    time: "6–8 months",
    from: "CAD 4,500+",
    link: "/canada-pr",
  },
  {
    id: "uk",
    country: "United Kingdom",
    city: "London",
    lat: 51.507,
    lon: -0.128,
    code: "GB",
    route: "Russell Group · Skilled Worker",
    headline: "Two years to work after you graduate",
    detail:
      "Direct admission to Russell Group and top-40 universities, plus the Graduate Route so your degree keeps paying after it ends.",
    time: "3–6 months",
    from: "GBP 3,200+",
    link: "/study",
  },
  {
    id: "usa",
    country: "United States",
    city: "New York",
    lat: 40.713,
    lon: -74.006,
    code: "US",
    route: "F-1 · STEM OPT",
    headline: "Three extra years on a STEM degree",
    detail:
      "F-1 filing and interview rehearsal, scholarship mapping across 200+ campuses, and the STEM OPT extension planned from day one.",
    time: "8–12 months",
    from: "USD 5,500+",
    link: "/study",
  },
  {
    id: "germany",
    country: "Germany & Europe",
    city: "Berlin",
    lat: 52.52,
    lon: 13.405,
    code: "DE",
    route: "Blue Card · Opportunity Card",
    headline: "A public degree that costs no tuition",
    detail:
      "Tuition-free public universities, English-taught Masters, the EU Blue Card for professionals and the Opportunity Card for job seekers.",
    time: "3–5 months",
    from: "EUR 2,800+",
    link: "/europe-visa",
  },
  {
    id: "australia",
    country: "Australia",
    city: "Sydney",
    lat: -33.868,
    lon: 151.209,
    code: "AU",
    route: "Group of Eight · 189/190/491",
    headline: "Points that add up to residency",
    detail:
      "Group of Eight admissions and the skilled occupation list read properly — including the regional bonus most applicants leave on the table.",
    time: "6–9 months",
    from: "AUD 4,700+",
    link: "/study",
  },
  {
    id: "uae",
    country: "UAE & Dubai",
    city: "Dubai",
    lat: 25.205,
    lon: 55.271,
    code: "AE",
    route: "Golden Visa · Zero tax",
    headline: "Ten-year residency, four hours away",
    detail:
      "Golden Visa tracks for investors, specialists and executives — the fastest residency we file, and the closest to home.",
    time: "1–2 months",
    from: "AED 9,000+",
    link: "/migrate",
  },
];
